module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }